<template>
  <div class="col-lg-3 mb-4 col-6 product-grid no-overflow">
    <div class="product-wrapper text-center">
      <div class="product-img px-4 py-3 position-relative">
        <add-to-wishlist v-if="isLoggedIn" :prod="product" class="fr-wish"></add-to-wishlist>
        <div class="ribbon" v-if="product.highlight_name && isLoggedIn">
          <span :style="`border-color: ${product.highlight_hex_code}; background: ${product.highlight_hex_code}; background: linear-gradient(${ product.highlight_hex_code } 0%, ${ product.highlight_hex_code } 100%);`">{{ product.highlight_name }}</span>
        </div>
        <img v-if="product.image" :src="product.image" class="" :alt="product.product_name" />
        <img v-else :src="`${$imagePath}` + getDefaultImage(product.product_type_id)" class="" :alt="product.product_name" />
      </div>
      <div class="px-3 pb-3">
        <div class="product-details">
          <div class="product-name  mb-1">
            <break-down :key="`${product.id}-${product.breakdown}`" :breakdowns="product.breakdown" :programCode="product.programtype" />
            <span class="d-inline-block highlight-description" v-if="product.highlight_description">
              <Popper :arrow="true" :hover="true" :content="product.highlight_description" style="margin:0; border: none;">
                <i class="fa-solid fa-circle-info info-icon"></i>
              </Popper>
            </span>
            {{ product.name }}
            <br />
            <Popper v-if="product.country_id > 0" :arrow=true :hover=true :content="product.country_label">
              <div class="text-center is_us_container">
                <span class="us_img_icon">
                  <img :src="`${$imagePath}` + product.country_flag"/>
                </span>
              </div>
            </Popper>
            <Popper v-if="product.state_id > 0" :arrow=true :hover=true :content="product.state_label">
              <div class="text-center is_us_container">
                <span class="us_img_icon">
                  <img :src="`${$imagePath}` + product.state_flag"/>
                </span>
              </div>
            </Popper>
          </div>
          <template v-if="isLoggedIn">
            <p>
              <small>
                <span>
                  <template v-if="!product.unlimited_quantity">
                    {{ product.unit_quantity }}&nbsp;{{ product.uom_display ? product.unit_quantity > 1 ? product.uom_plural : product.uom_name : '' }}
                  </template>
                  <template v-else>{{ product.uom_name }}</template>
                </span>
              </small>
            </p>
            <p><small>&nbsp;</small></p>
            <p>
              <b>${{ $filters.numberFormat(product.price_per_stem) }} / {{ product.uom_name }}</b>
              <Popper v-if="product.special" :arrow="true" :hover="true" :content="`${product.special}% Off`">
                <div class="ms-2 badge bg-peach">
                  <span>{{ product.special }}% Off</span>
                </div>
              </Popper>
            </p>
            <p>
              <small v-if="product.increment_quantity > 1">
                ${{ $filters.numberFormat(product.price_per_unit) }} /
                {{ product.inc_quantity }} {{ product.uom_plural }}
              </small>
              <small v-else>&nbsp;</small>
            </p>
          </template>
        </div>
        <div class="d-flex align-items-center justify-content-center my-2">
          <a
            v-if="!isLoggedIn"
            :href="'/login'"
            class="btn btn-theme ml-1"
            >Login</a
          >
          <template v-else>
            <add-to-cart
              :prod="product"
              :min="product.min_qty"
              :step="product.inc_qty"
              :deliveryDate="deliveryDate"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AddToCart from "./AddToCart.vue";
import AddToWishlist from "./AddToWishlist.vue";
import BreakDown from "./BreakDown.vue";
import Popper from "vue3-popper";
import { useGetters, useMisc } from "@/composables";

defineProps({
  max: {
    type: Number,
    default: 1,
  },
  product: {
    type: Object,
    required: true,
  },
  deliveryDate: {
    required: true,
  },
});

const { isLoggedIn } = useGetters();
const { getDefaultImage } = useMisc();

// Data
const us_message = ref('US Product');

// Lifecycle
onMounted(() => {
  let site_settings = JSON.parse(localStorage.getItem('site_settings'));
  us_message.value = site_settings.us_flag_message;
});
</script>

<style scoped>
.card {
  border: 1px solid #000;
  padding: 5px;
  margin-right: 10px;
}
.no-overflow {overflow: initial;}
.no-overflow .product-wrapper,.no-overflow .product-wrapper  .product-img{ overflow: initial !important;}
.us_img_icon {width:40px;}
/* .us_img_icon img{width:40px; height: 20px;} */
.is_us_container {width: 40px; margin: 0px auto;}
.star-color {
  color: #f37f62;
}
.product-name a {text-decoration: none;}
</style>
<style>
.tbl_breakdown {    
  color: #fff;
  font-size: 12px;
  font-weight: normal;

}

.text-center .tbl_breakdown th, .text-center .tbl_breakdown th{    
  text-align-last: initial;
  padding-left:5px;
}

.text-left {
  text-align-last: initial !important;
  padding-left: 5px;
}
.text-left td {
  padding-left: 5px !important;
}
@media screen and (max-width : 480px) {
	.product-name {
    text-decoration: none;
    font-size: 12px;
    height: 70px !important;
  }
}
</style>